module.exports = __webpack_public_path__ + "img/diaceutics-brand-gradients-07.832ab218.png";